import { useState } from "react";
import LoyaltyHistoryView from "../components/loyalty-history/LoyaltyHistoryView";
import { Button, Col, Modal, Row, Space, Typography, message } from "antd";
import { SearchQuery } from "../code/search-query/search-query";
import { getLoyaltyHistoryExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import LoyaltyView from "../components/loyalty-history/LoyaltyView";
import { LoyaltyHistory } from "../repository/data.default";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function LoyaltyHistoryPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [loyaltyInputValues, setLoyaltyInputValues] = useState({} as any);
  const [loyaltyInputOpen, setLoyaltyInputOpen] = useState(false);

  // Events

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onLoyaltyInputOpen(
    values?: LoyaltyHistory,
  ): void {
    setLoyaltyInputOpen(true);
    setLoyaltyInputValues(
      values
        ? {
            uid: values.uid,
          }
        : ({} as any),
    );
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading loyalty history export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getLoyaltyHistoryExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  function onLoyaltyClose(): void {
    setLoyaltyInputOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Loyalty History
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("Rewards", "view")}
            onClick={() => onDownloadExport()}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <LoyaltyHistoryView
          onSearch={onSearch}
          onAction={(key: string, record: any) =>
            onLoyaltyInputOpen(record)
          }
        />
      </Col>
      <LoyaltyView
        open={loyaltyInputOpen}
        uid={loyaltyInputValues.uid}
        onCancel={onLoyaltyClose}
      />
      {contextHolder}
    </Col>
  );
}

export default LoyaltyHistoryPage;
